import { render, staticRenderFns } from "./classSyncProjection.vue?vue&type=template&id=b0e79b7e&scoped=true&"
import script from "./classSyncProjection.vue?vue&type=script&lang=js&"
export * from "./classSyncProjection.vue?vue&type=script&lang=js&"
import style0 from "./classSyncProjection.vue?vue&type=style&index=0&id=b0e79b7e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e79b7e",
  null
  
)

export default component.exports